/**
 * マウス追従
 */
import AnyStore from "./AnyStore";

export default class MouseStalker {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'Gnav';

    if (Useragnt.pc) {
      this.el = document.getElementById('mouse-stalker');
      this.mouseX = 0;
      this.mouseY = 0;
      this.bindLoop = this.loop.bind(this);

      //this.init();
    }
  }

  /**
   * 初期化
   */
  init() {
    this.el.style.display = 'block';

    document.addEventListener('mousemove', this.stalking.bind(this));

    this.start();
  }

  /**
   * mousemove
   */
  stalking(e) {
    this.mouseX = e.pageX;
    this.mouseY = e.pageY;
  }

  /**
   * アニメループ
   */
  loop() {
    //TweenMax.to(this.el, 0.5, {x: this.mouseX, y: this.mouseY, ease: Cubic.easeInOut});
    requestAnimationFrame(this.bindLoop) ;
  }

  /**
   * 開始
   */
  start() {
    if (Useragnt.pc) {
      //this.loop();
    }
  }
}
